import { useTranslation } from 'react-i18next';
import ModelItem from './Partials/ModelItem';
import { useAsync } from 'react-async';
import { getToConnectionRequestModels } from 'api/node/toConnectionRequestModel';
import { KoobCard, KoobPlaceholder } from '@koob/ui';
import LocationAwareSearch from 'components/LocationAwareSearch';
import { useSearchParams } from 'hooks';
import { isEqual } from 'lodash';

export default function ToConnectionRequestModels() {
  const { t } = useTranslation('toConnectionRequest', { keyPrefix: 'models' });
  const [{ search }] = useSearchParams();

  const { data, isLoading, reload } = useAsync({
    promiseFn: getToConnectionRequestModels,
    filters: {
      search,
    },
    watchFn: (props, prevProps) => {
      return !isEqual(props.filters, prevProps.filters);
    },
  });

  const models = data?.data ?? [];

  return (
    <div className="max-w-7xl mx-auto min-h-[150vh] px-4 py-8">
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3 mb-6">
        <div className="flex flex-wrap items-center gap-3">
          <h2 className="text-lg font-semibold text-gray-800 whitespace-nowrap">
            {t('title')}
          </h2>
          {models.length > 0 && (
            <span className="shrink-0 whitespace-nowrap px-2 py-1 text-xs font-medium text-gray-500 bg-gray-200 rounded-full">
              {t('counter', { count: models.length })}
            </span>
          )}
        </div>

        <div className="w-full sm:w-72 sm:ml-auto">
          <LocationAwareSearch name="search" />
        </div>
      </div>

      <KoobCard>
        <div className="flex flex-col gap-3">
          {isLoading && (
            <KoobPlaceholder count={4} className="w-full px-4 py-8" />
          )}

          {!isLoading && models.length === 0 && (
            <div className="text-center py-12 text-gray-400">
              <i className="fa-regular fa-folder-open text-4xl mb-3" />
              <p className="text-sm">{t('noModels')}</p>
            </div>
          )}

          {!isLoading &&
            models.length > 0 &&
            models.map((model) => (
              <ModelItem key={model.id} model={model} reload={reload} />
            ))}
        </div>
      </KoobCard>
    </div>
  );
}
